var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-ppt-component",class:[_vm.showSpace ? 'lanx-space' : '']},[_c('div',{staticClass:"none-list-block",staticStyle:{"color":"#888","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.$t('workbench.component_PreviewPPT_tips_1'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }